import fetch from "isomorphic-fetch";
import { toast } from "saphir";
import { z } from "zod";

import { i18n } from "@lib/i18n";
import { handleError } from "@lib/utils/error";
import { recurrenceOptions } from "@routes/TaskPosting/ShiftsStep/useShiftAPI";

import { withAccountAuthHeaders } from "./apiHelpers";
import { apiConf, shiftShchema } from "./index";

const updateShiftSchema = z.object({
    shift: shiftShchema.extend({ id: z.string() }),
    scope: recurrenceOptions,
});

export type UpdateShiftParams = z.input<typeof updateShiftSchema>;
export async function updateShift(params: UpdateShiftParams) {
    const urlParams = new URLSearchParams();
    if (params.scope) {
        urlParams.append(`scope`, params.scope);
    }

    try {
        const resp = await fetch(
            withAccountAuthHeaders(
                `${apiConf.BACK_URL}/shifts/${params?.shift.id}?${urlParams.toString()}`,
                {
                    method: `PATCH`,
                    body: JSON.stringify({
                        ...params.shift,
                    }),
                },
            ),
        );

        if (resp.status === 400) {
            toast.error(i18n.error_invalid_shift());
            return {};
        }

        if (resp.status >= 400) {
            handleError(await resp.json(), resp.status);
            return Promise.reject(new Error("updateShift"));
        }

        return resp.json();
    } catch (e) {
        handleError(e, 500);
        return Promise.reject(new Error("updateShift"));
    }
}
